"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const fp_1 = require("lodash/fp");
const date_utils_1 = __importDefault(require("../../lib/date-utils"));
const typography_1 = require("../../styles/typography");
const styled_div_1 = __importDefault(require("../styled-div"));
const calendar_cell_1 = __importStar(require("./calendar-cell"));
const calendar_header_1 = __importDefault(require("./calendar-header"));
const Row = styled_components_1.default.div.attrs((props) => ({
    isHeading: props.isHeading || false,
})) `
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  padding: ${(props) => props.theme.spacing.xxs};
  ${(props) => props.isHeading &&
    `
    color: ${props.theme.colors.textLight};
  `}
`;
const CalendarModalContainer = styled_components_1.default.span `
  ${typography_1.smallText}

  text-align: center;
  background-color: ${(props) => props.theme.colors.white};
  justify-content: center;
  position: absolute;
  z-index: 3;
  border-radius: ${(props) => props.theme.borderRadius};
  left: 0.25rem;
  margin-top: ${(props) => props.theme.spacing.xs};
  width: 300px;
  box-shadow: 10px 10px 40px rgba(0, 0, 0, 0.2);
  border-radius: ${(props) => props.theme.borderRadius};
  background-color: ${(props) => props.theme.colors.white};
  overflow: hidden;
  padding: ${(props) => props.theme.spacing.xxs};
  :focus-visible {
    outline: ${(props) => props.theme.outline};
  }
`;
const CalendarModal = ({ viewingDate, selectedDate, onViewingDateChange, onSelectedDateChange, handleInputChange, maxDate, minDate, locale, }) => {
    // returns the heading of weekday names
    const daysOfWeek = () => {
        const days = [];
        for (let i = 0; i < 7; i += 1) {
            days.push(react_1.default.createElement(calendar_cell_1.Column, { key: i }, date_utils_1.default.getDayName(i, locale)));
        }
        return react_1.default.createElement(Row, { isHeading: true }, days);
    };
    // Returns array of Row components, each representing a week in a month
    const calendarGrid = () => {
        const monthComponents = [];
        // 2D array of numbers for the day of the month
        const month = date_utils_1.default.getMonthArray(viewingDate);
        // Transform each day into CalendarCell components
        for (let i = 0; i < month.length; i += 1) {
            const week = [];
            for (let j = 0; j < month[i].length; j += 1) {
                const cellDate = {
                    day: month[i][j],
                    month: viewingDate.month,
                    year: viewingDate.year,
                };
                const isSelected = fp_1.isEqual(cellDate, selectedDate);
                week.push(react_1.default.createElement(calendar_cell_1.default, { key: `${i}${j}`, cellDate: cellDate, isSelected: isSelected, isDisabled: !date_utils_1.default.withinRange(cellDate, minDate, maxDate), onDateChange: onSelectedDateChange, handleInputChange: handleInputChange }));
            }
            monthComponents.push(react_1.default.createElement(Row, { key: i }, week));
        }
        return monthComponents;
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(CalendarModalContainer, { "data-testid": "date-picker-calendar-popup" },
            react_1.default.createElement(calendar_header_1.default, { viewingDate: viewingDate, onViewingDateChange: onViewingDateChange, maxDate: maxDate, minDate: minDate, locale: locale }),
            react_1.default.createElement(styled_div_1.default, null,
                daysOfWeek(),
                calendarGrid()))));
};
exports.default = CalendarModal;
